<template>

<div class="floatingpane" v-if="builder.mode == 'quote' && !builder.quoteIsViewable" @keyup.enter="save($event)">
  <h3 v-html="builder.messages.viewQuoteTitle" style="margin-bottom: 7px;"></h3>
  <p v-html="builder.messages.viewQuoteText"></p>

  <p v-if="builder.errors.length" style="color: red; font-size: 14px; font-weight: bold;">
    <template v-for="(error, index) in builder.errors" :key="index">
      <span v-html="error"></span><br />
    </template>
  </p>

  <div class="floatingpane-form" :class="{ 's_loading' : builder.isSubmitted }">

    <!-- loading -->
    <div class="loader">
      <svg class="circular-loader" viewBox="25 25 50 50" >
        <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#ffffff" stroke-width="3" />
      </svg>
    </div>

    <div style="position: relative;">

      <label for="firstName" style="margin-bottom: 10px; text-align: left;">First Name *</label>

      <Text-Input
      key="firstName"
      field-label="firstName"
      field-name="firstName"
      :init-value=builder.quote.firstName
      :init-touched="false"
      scope="quote"
      @update-value="updateQuoteValue"
      ></Text-Input>

      <div
      :id="`firstNameErrors`"
      aria-live="polite"
      aria-relevant="additions removals">
        <div
        v-if="!_.isUndefined(builder.quoteValidation.firstName) && builder.quoteValidation.firstName.length"
        v-html="builder.quoteValidation.firstName"
        class="builderinput-error">

        </div>
      </div>

    </div>

    <div style="position: relative;">

      <label for="email" style="margin-top: 20px; margin-bottom: 10px; text-align: left;">Email *</label>

      <Text-Input
      key="email"
      field-label="email"
      field-name="email"
      field-type="email"
      :init-value=builder.quote.email
      :init-touched="false"
      scope="quote"
      @update-value="updateQuoteValue"
      ></Text-Input>

      <div
      :id="`emailErrors`"
      aria-live="polite"
      aria-relevant="additions removals">
        <div
        v-if="!_.isUndefined(builder.quoteValidation.email) && builder.quoteValidation.email.length"
        v-html="builder.quoteValidation.email"
        class="builderinput-error">

        </div>
      </div>

    </div>

    <div style="position: relative;">

      <label for="phone" style="margin-top: 20px; margin-bottom: 10px; text-align: left;">Phone</label>

      <Text-Input
      key="phone"
      field-label="phone"
      field-name="phone"
      field-type="phone"
      :init-value=builder.quote.phone
      :init-touched="false"
      scope="quote"
      @update-value="updateQuoteValue"
      ></Text-Input>

      <div
      :id="`phoneErrors`"
      aria-live="polite"
      aria-relevant="additions removals">
        <div
        v-if="!_.isUndefined(builder.quoteValidation.phone) && builder.quoteValidation.phone.length"
        v-html="builder.quoteValidation.phone"
        class="builderinput-error">

        </div>
      </div>

    </div>

    <!-- <label for="timeline" style="margin-top: 20px; margin-bottom: 10px; text-align: left;">Project Timeline</label>

    <Select-Input
    :key=builder.timeline.fieldName
    :field-label=builder.timeline.fieldName
    :field-name=builder.timeline.fieldName
    :init-value=builder.quote.timeline
    :init-touched="false"
    options-source="timelineOptions"
    scope="quote"
    @update-value="updateQuoteValue"
    ></Select-Input> -->

    <button class="button l_icon l_base l_strong" style="margin-top: 20px;" @click.stop="save($event)">
      <span class="btn-text" v-html="builder.messages.viewQuoteButtonText"></span>
      <span class="btn-icon">
        <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
      </span>
    </button>

  </div>

</div>

</template>

<script setup>

var _ = require('lodash');
const dayjs = require('dayjs')
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

import { ref, computed, onMounted, onUnmounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function save(e) {
  const emailValid = validateQuoteValue('email', builder.quote.email);
  const phoneValid = validateQuoteValue('phone', builder.quote.phone);
  const firstNameValid = validateQuoteValue('firstName', builder.quote.firstName);
  if (emailValid && firstNameValid) {
    saveCurrentItem(false, false, true);
  }
}

function saveCurrentItem(nextStep = false, exit = false, conversion = null) {
  return builder.saveCurrentItem(nextStep, exit, conversion);
}

function validateQuoteValue(prop, val) {
  let isValid = true;
  if (prop == 'email') {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || !val.length) {
      isValid = false;
      builder.quoteValidation['email'] = 'Please enter a valid email address';
    } else {
      builder.quoteValidation['email'] = '';
    }
  }
  if (prop == 'phone') {
    if (val && val.length) {
      val = val.replace(/ /g,'');
      if (!/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(val)) {
        isValid = false;
        builder.quoteValidation['phone'] = 'Please enter a valid phone number';
      } else {
        builder.quoteValidation['phone'] = '';
      }
    } else {
      builder.quoteValidation['phone'] = '';
      // builder.quoteValidation['phone'] = 'Please enter a valid phone number';
    }
  }
  if (prop == 'firstName') {
    if (_.isNull(val) || !val.length) {
      isValid = false;
      builder.quoteValidation['firstName'] = 'Please enter a valid name';
    } else {
      builder.quoteValidation['firstName'] = '';
    }
  }
  return isValid;
}

function updateQuoteValue(prop, val) {
  validateQuoteValue(prop, val);
  builder.quote[prop] = val;
}

</script>
